export default function Beta() {
  return (
    <div style={page}>
      <div style={card}>
        <div style={eyebrow}>EmPi Pilot</div>
        <h1 style={title}>The first pilot is complete.</h1>
        <p style={bodyText}>
          Thank you to everyone who took part and helped shape EmPi.
        </p>
        <p style={subtleText}>EmPi is now preparing its next phase.</p>
        <a href="/" style={link}>
          ← Back to homepage
        </a>
      </div>
    </div>
  );
}

const colors = {
  background: "#F5F5F7",
  card: "#FFFFFF",
  text: "#1D1D1F",
  secondaryText: "#6E6E73",
  border: "#E5E5E7",
};

const page = {
  minHeight: "100vh",
  background: colors.background,
  padding: "40px 20px",
  color: colors.text,
};

const card = {
  maxWidth: 560,
  margin: "0 auto",
  background: colors.card,
  border: `1px solid ${colors.border}`,
  borderRadius: 24,
  padding: 28,
  boxShadow: "0 8px 24px rgba(0,0,0,0.04)",
};

const eyebrow = {
  fontSize: 12,
  letterSpacing: 1.2,
  textTransform: "uppercase",
  color: colors.secondaryText,
  marginBottom: 10,
};

const title = {
  margin: "0 0 10px",
  fontSize: 32,
  lineHeight: 1.1,
  color: colors.text,
};

const bodyText = {
  margin: "0 0 8px",
  fontSize: 16,
  lineHeight: 1.6,
  color: colors.text,
};

const subtleText = {
  margin: "0 0 18px",
  fontSize: 15,
  lineHeight: 1.6,
  color: colors.secondaryText,
};

const link = {
  display: "inline-block",
  marginTop: 8,
  color: colors.text,
  fontWeight: 600,
  textDecoration: "none",
};
